var React = require('react');

function SearchOrange (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"30.5","cy":"30.5","r":"25.5","stroke":"#DC6238","strokeWidth":"9","key":0}),React.createElement("line",{"x1":"50.6569","y1":"51","x2":"69","y2":"69.3431","stroke":"#DC6238","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

SearchOrange.defaultProps = {"width":"75","height":"75","viewBox":"0 0 75 75","fill":"none"};

module.exports = SearchOrange;

SearchOrange.default = SearchOrange;
